// Carla, 2026-10-12: her learnt task priority and meeting platform, with their modes, for the forms
// (GET /api/aidey-intelligence/defaults; the server's rule is Aidey Backend/lib/learntDefaults.js).
//   { taskPriority: { priority, mode } | null, meetingPlatform: { platform, label, mode } | null }
// Suggest: a form starts on the value, marked as Aidey's suggestion. Auto: the form starts on it and
// says Aidey set it. Read once per page load and shared; a failed read is simply no suggestion (the
// form works exactly as before, and the server still applies Auto wherever nothing was chosen).
import { useEffect, useState } from 'react';
import { api } from '../api/client';

let cached = null;
let inflight = null;

function load() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api('/api/aidey-intelligence/defaults')
      .then((r) => r.json())
      .then((d) => { cached = { taskPriority: d?.taskPriority || null, meetingPlatform: d?.meetingPlatform || null }; return cached; })
      .catch(() => ({ taskPriority: null, meetingPlatform: null }))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

// Tests, and a change of mode on Settings, start the next read fresh.
export function resetLearntDefaults() { cached = null; inflight = null; }

// The form's names for the server's platforms.
export const PLATFORM_TO_MEETING_TYPE = { zoom: 'Zoom', meet: 'Google Meet', teams: 'Teams' };

export function useLearntDefaults(enabled = true) {
  const [value, setValue] = useState(cached);
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    load().then((d) => { if (live) setValue(d); });
    return () => { live = false; };
  }, [enabled]);
  return value;
}
